import { useCallback } from "react";

import { Grid } from "@mui/material";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { LoadingOrValue } from "@covertree/ui";

import { AdditionalInsured as AdditionalInsuredGraphQL } from "@covertree/agent-portal-graphql";
import { mapAdditionalInsuredName } from "@utils/mapAdditionalInsuredName";
import { mapRelationship } from "@utils/mapRelationshipToInsured";
import { PolicyDetailsContentProps } from "../../../types";

export const AdditionalInsured = ({
  policy,
  loading,
}: PolicyDetailsContentProps) => {
  const getPropertiesPerItem = useCallback(
    (additionalInsured: AdditionalInsuredGraphQL, isFirstItem = false) => [
      {
        label: "Additional insured",
        value: isFirstItem ? (
          <LoadingOrValue
            loading={!policy && loading}
            value={mapAdditionalInsuredName(additionalInsured)}
            height={24}
            width={121}
          />
        ) : (
          mapAdditionalInsuredName(additionalInsured)
        ),
        showAsTypography: true,
        gridSize: 6,
      },
      {
        label: "Relationship to primary insured",
        value: isFirstItem ? (
          <LoadingOrValue
            loading={!policy && loading}
            value={mapRelationship(additionalInsured?.relationshipIndividual)}
            height={24}
            width={121}
          />
        ) : (
          mapRelationship(additionalInsured?.relationshipIndividual)
        ),
        showAsTypography: true,
        gridSize: 6,
      },
    ],
    [policy?.additionalInsured]
  );

  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        properties={[
          ...getPropertiesPerItem(policy?.additionalInsured[0], true),
          ...(policy?.additionalInsured.length > 1
            ? policy?.additionalInsured
                .slice(1)
                .map((additionalInsured) =>
                  getPropertiesPerItem(additionalInsured)
                )
                .flat()
            : []),
        ]}
      />
    </Grid>
  );
};
